import { render, staticRenderFns } from "./signList.vue?vue&type=template&id=5c720ee6&"
import script from "./signList.vue?vue&type=script&lang=ts&"
export * from "./signList.vue?vue&type=script&lang=ts&"
import style0 from "./signList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports